<template>
  <v-autocomplete
    v-model.trim="localValue"
    :items="timezones"
    :label="$t('labels.timezone')"
    :error-messages="errors"
  />
</template>

<script>
import moment from 'moment-timezone'
import { CustomFieldMixin } from '../mixins'

export default {
  name: 'TimezoneField',
  mixins: [CustomFieldMixin],
  data: () => ({
    timezones: moment.tz.names()
  })
}
</script>
